import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "Inner",
  componentId: "sc-9g1d4l-0"
})(["display:block;width:100%;height:100%;min-height:120px;"]);